import { formatFullDate } from 'src/utils/dateFormatter';

type CalendarViewMode = 'timeGridWeek' | 'resourceTimeGridDay' | 'listWeek';

export function getCalendarHeaderTitle(
  view: CalendarViewMode,
  date: Date | null | undefined,
  calendarTitle: string
): string {
  if (view === 'resourceTimeGridDay' && date) {
    return formatFullDate(date);
  }

  return calendarTitle;
}
